import React from 'react';

import Link from 'common/Link';

import 'css/components/www/_LandingCTAButtons.scss';

type Props = {
  renderDemoButton?: boolean;
};
const LandingCTAButtons = ({ renderDemoButton }: Props) => {
  return (
    <div className="landingCTAButtons">
      <Link className="LandingGlobal__cta" to="/register">
        Get started
      </Link>
      {renderDemoButton && (
        <Link className="LandingGlobal__cta LandingGlobal__cta--outlined" to="/request-demo">
          Request a demo
        </Link>
      )}
    </div>
  );
};

export default LandingCTAButtons;
